import { Browser, OpenOptions } from '@capacitor/browser';
import { captureException } from '@sentry/react';

export function useBrowser() {
  const defaultOpenOptions: OpenOptions = {
    url: '',
    presentationStyle: 'popover',
  };

  return {
    close: Browser.close,
    open: async (
      options: Partial<OpenOptions>,
      e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
      e?.preventDefault();
      Browser.open({
        ...defaultOpenOptions,
        ...options,
      }).catch((error) => {
        console.error(error);
        captureException(error);
      });
    },
  };
}
